<template>
  <div class="row-element">
    <slot name="anchor"></slot>
    <el-switch
      v-model="element.disabled"
      :active-value="false"
      :inactive-value="true"
      style="transform: scale(.75)"
    >
    </el-switch>
    <i
      :class="['el-icon-view handler', { disabled: !element.visible }]"
      @click="element.visible = !element.visible"
    />
    <icon-select-element
      :icons="availableIcons"
      v-model="element.icon"
      style="width: 120px"
      :size="elSize"
    />
    <el-input
      placeholder="Title"
      :size="elSize"
      v-model="element.title"
      style="width: 150px"
    />
    <el-input
      placeholder="URL"
      v-model="element.link"
      :size="elSize"
      style="width: 300px"
      clearable
    />
  </div>
</template>

<script>
import MenuElement from "../../../store/classes/MenuEditor/MenuElement";
import IconSelectElement from "./icon-select-element";

export default {
  name: "row-element",
  components: { IconSelectElement },
  props: {
    element: {
      type: MenuElement,
      required: true
    },
    availableIcons: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    elSize: "mini",
    linkPrefix: "https://"
  })
};
</script>

<style scoped lang="stylus">
.handler
    i&
        cursor pointer
        color #13ce66
        &.disabled
            color #e2e2e2
.row-element
    & > *:not(:last-child):not(:first-child)
        margin-right 10px
</style>
